import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MarkerPin04 = function MarkerPin04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 14.2864c-1.8514.8167-3 1.9548-3 3.2136C2 19.9853 6.4772 22 12 22s10-2.0147 10-4.5c0-1.2588-1.1486-2.3969-3-3.2136M18 8c0 4.0637-4.5 6-6 9-1.5-3-6-4.9363-6-9 0-3.3137 2.6863-6 6-6s6 2.6863 6 6m-5 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default MarkerPin04;